import { render } from "./ConfirmSendMoney.vue?vue&type=template&id=ee65641c"
import script from "./ConfirmSendMoney.vue?vue&type=script&lang=js"
export * from "./ConfirmSendMoney.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__